import { render, staticRenderFns } from "./SummaryDirectionsOfUseTab.vue?vue&type=template&id=714922ea&scoped=true"
import script from "./SummaryDirectionsOfUseTab.vue?vue&type=script&lang=js"
export * from "./SummaryDirectionsOfUseTab.vue?vue&type=script&lang=js"
import style0 from "./SummaryDirectionsOfUseTab.vue?vue&type=style&index=0&id=714922ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714922ea",
  null
  
)

export default component.exports